<template lang="pug">
  div(v-click-outside="clickOutside").inline-editor-wrapper
    .inline-editor(v-show="editing")
      .inline-editor__controls
        div
          input.form-control.input-sm(type='text' maxlength='16' @keyup.enter="saveEdit" ref="editorInput" :disabled="isSaving" :readonly="isSaving" v-model="value")
        .editable-buttons(v-if="!isSaving")
          button.btn.btn-primary.btn-sm.editable-submit(type='submit' :disabled="isSaving" @click.stop.prevent="saveEdit")
            i.glyphicon.glyphicon-ok
          button.btn.btn-default.btn-sm.editable-cancel(type='button' :disabled="isSaving" @click.stop.prevent="stopEdit")
            i.glyphicon.glyphicon-remove
        div(v-if="isSaving")
          circle-loader(size="29px")
            span
      .errors(v-if="hasError")
        div.error-message {{errorText}}
    template
      a(href="#" @click.prevent="startEdit" :class="editableLinkClass").editable-link
        template(v-if="hasName") {{ name }}
        template(v-else) <Нет имени>
    //.popover.fade.top.in.editable-container.editable-popup(role='tooltip')
      .arrow(style='left: 50%;')
      h3.popover-title Название счета
      .popover-content
        div
          .editableform-loading(style='display: none;')
          form.form-inline.editableform(style='')
            .control-group.form-group
              div
                .editable-input(style='position: relative;')
                  input.form-control.input-sm(type='text' maxlength='16' style='padding-right: 24px;')
                  span.editable-clear-x
                .editable-buttons
                  button.btn.btn-primary.btn-sm.editable-submit(type='submit')
                    i.glyphicon.glyphicon-ok
                  button.btn.btn-default.btn-sm.editable-cancel(type='button')
                    i.glyphicon.glyphicon-remove
              .editable-error-block.help-block(style='display: none;')

</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import { CryptoAddress, CryptoAddressRenameModel } from '@/models/finance/crypto';
import CircleLoader from '@/components/loaders/CircleLoader.vue';

@Component({
  name: 'crypto-address-name-inline-editor',
  components: { CircleLoader },
  directives: { ClickOutside },
})
export default class CryptoAddressNameInlineEditor extends Vue {
  @Prop({ required: true })
  address!: CryptoAddress;

  editing = false;

  renameModel: CryptoAddressRenameModel = new CryptoAddressRenameModel();

  get editableLinkClass() {
    return {
      editing: this.editing,
      'not-editing': !this.editing,
    };
  }

  clickOutside() {
    // console.log('click outside');
    this.stopEdit();
  }

  get name() {
    return this.address.name ? `${this.address.name}` : '';
  }

  get hasName() {
    return this.name.length > 0;
  }

  get popoverClass() {
    return {
      in: this.editing,
    };
  }

  value = '';

  startEdit() {
    this.value = this.name;
    this.renameModel.errors.clear();
    this.editing = true;
    Vue.nextTick(() => {
      if (this.$refs.editorInput) (this.$refs.editorInput as any).focus();
    });

    this.$emit('start-edit');
  }

  stopEdit() {
    this.editing = false;
  }

  get isSaving() {
    return this.editing && this.renameModel.state.isLoading;
  }

  saveEdit() {
    if (this.value === this.address.name) return this.stopEdit();
    this.renameModel.renameAddress(this.address.id, this.value)
      .then((address: CryptoAddress) => {
        this.stopEdit();
        this.$emit('update-address', address);
        return address;
      }).catch((err) => {
        throw err;
      });
  }

  get hasError() {
    return this.renameModel.hasErrors();
  }

  get errorText() {
    return this.renameModel.errors.getFirstError();
  }
}
</script>

<style scoped lang="less">
.editable-link {
  position: relative;
  &.editing {
    visibility: hidden;
  }
}

.inline-editor-wrapper {
  position: relative;
}
.inline-editor {

  position: absolute;
  width: 300px;
  left: 0; top: -17px;

  display: block;
  background: #FFFFFF;
  border: 3px solid #74a91d;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  box-shadow: 0px 16px 32px rgba(9, 9, 9, 0.12);
  border-radius: 6px;
  padding: 8px 5px 7px 15px;
  margin-left: 0;
  z-index: 100;

  .btn {
    height: 29px;
  }
  .inline-editor__controls {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: auto max-content;

  }
  .error-message {
    color: red;
    font-size: 90%;
    margin-top: 3px;
  }

  .editable-buttons {
    display: grid;
    grid-gap: 6px;
    grid-template-columns: 1fr 1fr;
  }

  .form-control {
    height: 29px;
  }
}
</style>
